var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "no-product": _vm.noProduct }, attrs: { id: "page_Container" } },
    [
      !_vm.noProduct
        ? _c("div", { staticClass: "page", attrs: { id: "group-detail" } }, [
            _c(
              "div",
              { attrs: { id: "main-container" } },
              [
                _c(
                  "van-panel",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "van-cell van-panel__header",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _c("van-tag", { attrs: { color: "#EE2E50" } }, [
                          _vm._v(_vm._s(_vm.groupData.groupName))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.groupData.productGroupItemList, function(
                      gooditem
                    ) {
                      return _c("Goods", {
                        key: gooditem.id,
                        staticStyle: { padding: "9px 12px" },
                        attrs: { goodsData: gooditem }
                      })
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "group-detail-footer" },
              [
                _c("op-submit-bar", {
                  attrs: {
                    num:
                      _vm.groupData.productGroupItemList &&
                      _vm.groupData.productGroupItemList.length,
                    price: _vm.groupData.groupSellPrice
                  },
                  on: {
                    submit: function($event) {
                      _vm.onSubmit(_vm.groupData)
                    }
                  }
                })
              ],
              1
            )
          ])
        : _c("div", { staticClass: "no-product" }, [
            _c("img", {
              attrs: {
                src: require("../assets/img/myCenter/noProduct.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", [_vm._v("套装商品已下架")])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }